import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
// Removed duplicate import of useStyles
import { useTheme } from "@mui/material/styles";
import GrnPdfHeader from "../../components/documents/GrnPdfHeader";
import GrnPdfFooter from "../../components/documents/GrnPdfFooter";
import ViewDataGridPdf from "../../components/grid/ViewDataGridPdf";
import { ViewGrnPdfData } from "../../components/grid/GridDataPdf";
import GrnPdfInfo from "../../components/documents/GrnPdfInfo";
import GrnPdfSupplier from "../../components/documents/GrnPdfSupplier";
import { FormatDate } from "../../utils/common/DateUtils";
import {  ThemeProvider } from "@mui/material/styles";
import { lightTheme, useStyles } from "../../assets/styles/Theme";
const cellStyleLabel = {
  border: "1px solid black",
  fontWeight: "bold",
  fontSize: 10,
  textAlign: "right",
  px: 1,
  py: 0.5,
  bgcolor: "white",

  color: "black",
};

const cellStyleValue = {
  border: "1px solid black",
  // backgroundColor: "#f3f3f3",
  bgcolor: "white",
  color: "black",
  fontSize: 10,
  px: 1,
  py: 0.5,
  textAlign: "right",
};

function GrnPdf({
  docType,
  grnHeader,
  selectedSupplier,
  grnDetailsForm,
  grnPaySummery,
  grnData,
  grnItems,
  grnCompany,
  grnReturns,
    grnRejectList
}) {

  // Ensure grnData and grnData.billings are always defined to prevent runtime errors
  grnData = grnData || {};
  grnData.billings = grnData.billings || {};

  const theme = useTheme();
  const styles = useStyles(theme);
  const printRef = useRef();
  const handlePrint = () => {
    window.print();
  };

  const summary = grnPaySummery?.[0] || {};
  const returnSummary = grnReturns?.[0] || {};

  console.log("returnSummary:", returnSummary);

  const formatCurrency = (val) =>
    new Intl.NumberFormat("en-LK", {
      // style: "currency",
      // currency: "LKR",
      minimumFractionDigits: 2,
    }).format(Number(val || 0));

const rejectionSource =
  Array.isArray(grnRejectList) && grnRejectList.length > 0
    ? grnRejectList
    : Array.isArray(grnReturns)
    ? grnReturns.filter((item) => item?.sts === "4")
    : [];

const grnItemsRows = (grnItems || grnData?.products)?.map(
  (item, index) => {
    const matchedReturn = rejectionSource.find(
      (ret) => ret?.productcode === item?.productcode
    );

    return {
      ...item,
      id: item?.productcode || index,
      idno: index + 1,
      returnedqty: matchedReturn?.returnedqty ?? 0,
      batchno: item?.batchno || item?.batchNo || "-", // Fallback for batch number
    };
  }
);

const grnItemsColumns = [
  { field: "idno", headerName: "No" ,width: 50},
  { field: "productcode", headerName: "Item Code" },
  { field: "productname", headerName: "Item Name" },

  { field: "immeasuringunit", headerName: "UOM" },
   { field: "unitprice", headerName: "Unit Price", format: formatCurrency },
  { field: "batchno", headerName: "Batch Number" },
 
  { field: "poqty", headerName: "PO Quantity" },
  { field: "receivedqty", headerName: "Received Quantity" },
  { field: "acceptedqty", headerName: "Accepted Quantity" },

  // Add your custom column here:
{
  field: "returnedqty",
  headerName: "Rejected Quantity",
},

  { field: "grossvalue", headerName: "Gross Amount", format: formatCurrency },
];

  const poData = grnHeader || grnDetailsForm || {};

  // Map API fields to UI fields with fallback keys for old data
  const poNumber = poData.ponumber || "-";
  const poDate = poData.podate || poData.poDate || null;
  const invoiceNumber = poData.invoiceno || poData.invoiceNumber || "N/A";
  const invoiceDate = poData.invoicedate || poData.invoiceDate || null;
  const deliveryNoteNumber =
    poData.deliverynoteno || poData.deliveryNoteNumber || "N/A";

  const billOfLandingNumber =
    poData.blno || poData.billOfLandingNumber || "N/A";

  return (
    <div ref={printRef} id="print-section">
       <ThemeProvider theme={lightTheme}>
     <Box
  sx={{
    width: "210mm",
    minHeight: "297mm",
    margin: "0 auto",
    padding: "10mm",
    bgcolor: "white",
    color: "black",
    boxSizing: "border-box",
  }}
>
        <GrnPdfHeader
          docType={docType}
          grnHeader={grnHeader}
          grnCompany={grnCompany}
          handlePrint={handlePrint}
        />

        <Divider sx={{ borderColor: "#2a6db0", mb: 4 }} />
        <Box mb={4}>
          <Typography variant="body_xs" component="span" fontWeight="bold">
            GRN ID:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {grnHeader?.grncode || "N/A"}
          </Typography>
          <br />
          <Typography variant="body_xs" component="span" fontWeight="bold">
            GRN DATE:
          </Typography>{" "}
          <Typography variant="body_xs" component="span">
            {FormatDate(poDate) || "-"}
          </Typography>
        </Box>

    <Box sx={styles.sup_buy_container}>
<Box sx={styles.sup_buy_container_inside}>
  <Typography variant="subtitle_s" fontWeight="bold" gutterBottom>
    PO INFORMATION
  </Typography>

  <TableContainer component={Paper}>
    <Table size="small" sx={{ "& td, & th": { borderBottom: "none" } }}>
      <TableBody>
        <TableRow>
          <TableCell >
            <Typography variant="body_xs" fontWeight="bold">
              PO NUMBER
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body_xs">{poNumber || "-"}</Typography>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <Typography variant="body_xs" fontWeight="bold">
              PO DATE
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body_xs">{FormatDate(poDate) || "-"}</Typography>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <Typography variant="body_xs" fontWeight="bold">
              INVOICE NUMBER
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body_xs">{invoiceNumber || "-"}</Typography>
          </TableCell>
        </TableRow>
  <TableRow>
          <TableCell>
            <Typography variant="body_xs" fontWeight="bold">
              INVOICE DATE
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body_xs">{FormatDate(invoiceDate) || "-"}</Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography variant="body_xs" fontWeight="bold">
              DELIVERY NOTE NUMBER
            </Typography>
          </TableCell>
          <TableCell >
            <Typography variant="body_xs">{deliveryNoteNumber !== "N/A" ? deliveryNoteNumber : "-"}</Typography>
           
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell>
            <Typography variant="body_xs" fontWeight="bold">
              BILL OF LADING
            </Typography>
          </TableCell>
          <TableCell>
            <Typography variant="body_xs">
             
              {billOfLandingNumber !== "N/A" ? billOfLandingNumber : "-"}</Typography>
          </TableCell>
        </TableRow>

      
      </TableBody>
    </Table>
  </TableContainer>
</Box>



          <Box sx={styles.sup_buy_container_inside} mt={-2}>
            <GrnPdfSupplier
              grnHeader={grnHeader}
              selectedSupplier={selectedSupplier}
            />
          </Box></Box>
        {/* <Box mb={4}>
        <Typography fontWeight="bold" mb={1}>
          RECEIVED BY:
        </Typography>
        <Typography>
          <Box component="span" fontWeight="bold">
            Name:
          </Box>
        </Typography>
        <Typography>
          <Box component="span" fontWeight="bold">
            Receiving Department:
          </Box>
        </Typography>
      </Box> */}
        <ViewDataGridPdf
          columns={grnItemsColumns}
          // rows={rows}
          // rows={filteredRows.map((item) => ({ ...item, id: item.field }))}
          // menuItems={menuItems}
          // tabletitle={ViewInitiatorGrnData.name}
          // gridid="field"
          sx={styles.view_data_grid_page}
          rows={grnItemsRows}
          gridid="productcode"
        />

        <Box
          display="flex"
          justifyContent="flex-end"
          mt={2}
          maxWidth={300}
          ml="auto"
        >
          <TableContainer component={Paper} sx={{ border: "1px solid black" }}>
            <Table size="small" sx={{ borderCollapse: "collapse" }}>
              <TableBody>
                <TableRow>
                  {/* <TableCell sx={cellStyleLabel}>TOTAL ITEMS</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {grnItemsRows.length}
                  </TableCell> */}
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}>GROSS VALUE</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.totgross || grnData.billings?.totalGross
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={cellStyleLabel}> DISCOUNT</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {/* {formatCurrency(
                      summary.totproductdiscount ||
                        grnData.billings?.productdiscountAmount
                    )} */}
                    {formatCurrency(
                      summary.totbulkdiscount > 0
                        ? summary.totbulkdiscount
                        : summary.totproductdiscount > 0
                        ? summary.totproductdiscount
                        : grnData.billings?.productdiscountAmount ?? 0
                    )}
                  </TableCell>
                </TableRow>
    <TableRow>
                  <TableCell sx={cellStyleLabel}>TAXABLE VALUE</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                     summary.totnettgross || grnData.billings?.taxableValue
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={cellStyleLabel}>TAX</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(
                      summary.tottax || grnData.billings?.vatAmount
                    )}
                  </TableCell>
                </TableRow>

                {/* <TableRow>
                  <TableCell sx={cellStyleLabel}>PENALTY</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(summary.totpenalty)}
                  </TableCell>
                </TableRow> */}
                <TableRow>
                  <TableCell sx={cellStyleLabel}>NET VALUE</TableCell>
                  <TableCell sx={{ ...cellStyleValue }}>
                    {formatCurrency(
  (Number(summary?.totnettgross) || 0) + (Number(summary?.tottax) || 0)
)}

                  </TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell sx={cellStyleLabel}>OTHER CHARGES</TableCell>
                  <TableCell sx={cellStyleValue}>
                    {formatCurrency(summary.totcharges || grnData.billings?.otherCharges)} </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={cellStyleLabel}>TOTAL INVOICE VALUE</TableCell>
                  <TableCell sx={cellStyleValue}>
                 

                        {formatCurrency(
                      summary.totinvoice || grnData.billings?.finalInvoiceValue
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Grid container py={1} mt={4} spacing={8}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              justifyItems: "flex-end",
              textAlign: "right",
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                justifyItems: "flex-end",
              }}
            > */}
            <Typography variant="body_xs">
              ..........................................{" "}
            </Typography>
            <Typography variant="body_xs">
              <strong>Checked & Authorized By</strong>
            </Typography>
            {/* </Box> */}
          </Grid>
          {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body_xs">
                <strong> Inspection Required:</strong>
              </Typography>
            </Box>
          </Grid> */}
        </Grid>
        {/* <Divider /> */}
        {/* <Box sx={{ mt: 1, display: "flex", flexDirection: "column" }}>
          <Typography variant="body_xs">
            <strong>
              {" "}
              Condition of items upon receipt (Condition or Discrepancy):{" "}
            </strong>
          </Typography>
          <Typography variant="body_xs">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
            aliquet ullamcorper auctor. Nunc tellus massa, condimentum a
            bibendum a, vestibulum eu dolor.
          </Typography>
        </Box> */}
        <GrnPdfInfo grnHeader={grnHeader} />

        <GrnPdfFooter />
      </Box> </ThemeProvider>
    </div>
  );
}

export default GrnPdf;
